import { h } from 'preact';

import GalleryEditor from 'components/editor/movies/gallery/gallery';

import s from 'components/editor/movies/gallery/galleryUniversal.sss';

export default class UniversalGalleryEditor extends GalleryEditor {
	s = s;
}
